import React from 'react';
import {Databox,LoadGraphic,Step} from '../components/Common';
import PublicPageLayout from '../components/PublicPageLayout';
import {Box,Button} from '../components/Input';
import sha from 'sha1';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import qs from 'query-string';
import '../styles/create-user.scss';

export default class CreateUser extends React.Component{

    state={
        loading:false,
        loadText: "Creating account...",
        step:"create",
        entryData:{},
        error:"",
    };

    componentDidMount=()=>{
        const query = qs.parse(this.props.location.search);
        const passToken = query.token;
        const email = query.user;

        if(typeof passToken == "undefined" || typeof email == "undefined") {
            this.setState({error:"Error! Please access this page from the link sent to your email"});
        }

        this.setState({instantiated:true,passToken:passToken,email:email});
    }

    onCreateUser=()=>{
        const input = ["password","passconf"];
        const entryData = this.state.entryData;

        for(var i=0; i<input.length; i++){
            const current = this.refs[input[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }

        if(entryData.password != entryData.passconf){
            this.setState({error:"Passwords do not match"});
            return 0;
        }

        this.setState({loading:true,error:""});

        u.post({
            url:"/noauth/create-user",
            data:{
                email:this.state.email,
                password:entryData.password,
                token:this.state.passToken
            },
            success:(callback)=>{
                this.setState({step:"success",loading:false});
            },
            error:(error,status)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    onChange=(value,label,index)=>{
        let entryData = this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    render=()=>{
        const enabled=(typeof this.state.passToken != "undefined");
        const entryData = this.state.entryData;

        return(
            <PublicPageLayout title="Create User Account" url="/create-user">
                <div style={{position:"relative",textAlign:"center"}}>
                    <div className="create-container">
                        <div className="cm-container" style={{backgroundColor:"#A81426"}}>
                            <h2 className="cm">Create User Account</h2>
                        </div>

                        <div className="page-error">{this.state.error}</div>

                        <Step active={(this.state.step == "create")}>
                            <div>
                                <div style={{position:"relative"}}>
                                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>

                                    <div className="create-form" style={{margin:"20px auto"}}>
                                        <div className="input-item">
                                            <div className="input-label">Email:</div>
                                            <Box ref="email" label="Email" values={{value:this.state.email,enabled:false}}/>
                                        </div>
                                        <div className="input-item">
                                            <div className="input-label">Password:</div>
                                            <Box ref="password" label="Password" field="password" type="password" values={{value:entryData.password,enabled:enabled}} rules={{required:true,minLength:8}} onChange={this.onChange}/>
                                        </div>
                                        <div className="input-item">
                                            <div className="input-label">Confirm Password:</div>
                                            <Box ref="passconf" 
                                                 label="Confirm Password" 
                                                 field="passconf" 
                                                 type="password" 
                                                 values={{value:entryData.passconf,enabled:enabled}} rules={{required:true}} onChange={this.onChange}/>
                                        </div>
                                    </div>

                                    <div className="input-button">
                                        <Button onClick={this.onCreateUser} enabled={enabled}>Create</Button>
                                    </div>
                                </div>
                            </div>
                        </Step>

                        <Step active={(this.state.step == "success")}>
                            <div style={{padding:"20px 0"}}>
                                <img src="/images/input/confirm.png" style={{height:"64px",margin:"20px auto 20px auto"}}/>
                                <h3>
                                    Account has been successfully created
                                </h3>
                            </div>
                        </Step>
                    </div>
                </div>
            </PublicPageLayout>
        )
    }
}
